import { render, staticRenderFns } from "./CollegeStaff.vue?vue&type=template&id=194276be"
import script from "./CollegeStaff.vue?vue&type=script&lang=js"
export * from "./CollegeStaff.vue?vue&type=script&lang=js"
import style0 from "./CollegeStaff.vue?vue&type=style&index=0&id=194276be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports